import { render, staticRenderFns } from "./WizardMobile.vue?vue&type=template&id=0ca87a42&scoped=true"
import script from "./WizardMobile.vue?vue&type=script&lang=js"
export * from "./WizardMobile.vue?vue&type=script&lang=js"
import style0 from "./WizardMobile.vue?vue&type=style&index=0&id=0ca87a42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca87a42",
  null
  
)

export default component.exports